<template>
  <section class="-left">
    <a :class="styles" :href="linkProcesso" @click.prevent="save">
      <svg v-if="iconName" :class="svgClasses">
        <use
          xmlns:xlink="http://www.w3.org/1999/xlink"
          :href="`/assets/svg/user/icons.svg#${iconName}`"
        ></use>
      </svg>
      <span>{{ label }}</span>
    </a>
    <modal-confirmar-email
      :loading="false"
      :email="email"
    ></modal-confirmar-email>
    <modal-campaign
      v-if="showModalCampaign"
      :campaign="campaign"
      @close="close"
    />
    <loading></loading>
  </section>
</template>
<script>
import * as modals from "./../../store/modal-types";
import * as types from "./../../store/mutation-types";
import { subdomainUrl } from "../../utils/url";
import ModalConfirmarEmail from "../monitoramentos/ModalConfirmarEmail";
import ModalCampaign from "../../components/modals/ModalCampaign";
import Loading from "../monitoramentos/Loading";
const ERROS_LIMITE_CRIACAO_MONITORAMENTO = [
  "Você alcançou o limite máximo de monitoramentos de termos",
  "Você alcançou o limite máximo de monitoramentos de processos",
];
export default {
  components: {
    ModalConfirmarEmail,
    ModalCampaign,
    Loading,
  },
  props: {
    email: {
      default: "",
      type: String,
    },
    linkClasses: {
      default: "btn -hasIcon",
      type: String,
    },
    confirmouEmail: {
      default: true,
      type: Boolean,
    },
    object: {
      type: Object,
      default: () => {
        return {};
      },
    },
    authUser: {
      type: String,
    },
    origemCriacao: {
      default: "BOTAO_MONITORAR_PAGINA_PROCESSO",
      type: String,
    },
    labelPersonalizado: {
      default: "Monitorar processo",
      type: String,
    },
    svgClasses: {
      default: "svg-icon -x20 -right -highlight",
      type: String
    },
    iconName: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      label: "Monitorar processo",
      showModalCampaign: false,
      titleModalNaoAssinante: "",
      errorMessage: "",
      monitorando: false,
    };
  },
  mounted() {
    this.$store.dispatch("getAuthUser");
    this.label = this.labelPersonalizado;
  },
  computed: {
    styles() {
      let styles = this.linkClasses;
      if (this.monitorando) {
        styles = `${styles} c-button--positive`;
      }
      return styles;
    },
    campaign() {
      return {
        id: 61,
        title: this.errorMessage,
        subscriber:
          "Mude para um plano que seja mais adequado às suas necessidades.",
        nonSubscriber: `Assine um de nossos planos para ter acesso a novos monitoramentos`,
        footer: "Faça mais a partir de ",
        planKey: this.object.key,
      };
    },
    user() {
      return this.$store.state.usuario.user;
    },
    assinatura() {
      return this.user.dados_assinatura || {};
    },
    assinaturaAtiva() {
      return this.assinatura.tem_premium;
    },
    linkProcesso() {
      return subdomainUrl(
        "www",
        "/login?auth.redirect=" +
          encodeURIComponent(
            subdomainUrl(
              "monitoramentos",
              `/novo?tipo=processo&termo=${
                this.object && this.object.termo
              }&ref=ClicouBotaoMonitorarProcesso&origem_criacao=BOTAO_MONITORAR_PAGINA_PROCESSO`
            )
          )
      );
    },
  },
  methods: {
    pluralize(categoria) {
      switch (categoria) {
        case "instituicao":
          return "empresas";
        default:
          return `${categoria}s`;
      }
    },
    toggleModalConfirmarEmail() {
      this.$store.commit(types.TOGGLE_MODAL, modals.CONFIRMAR_EMAIL);
    },
    close() {
      this.showModalCampaign = false;
    },
    save() {
      if (this.user && this.user.id) {
        if (!this.confirmouEmail) {
          this.toggleModalConfirmarEmail();
          return;
        }
        this.criarMonitoramento();
      } else {
        window.location.href = this.linkProcesso;
      }
      return;
    },
    criarMonitoramento() {
      let form = {};
      if (this.object.tipo === "processo") {
        form.numero_processo = this.object.termo;
      }

      this.label = "Carregando...";

      this.$store
        .dispatch("criarMonitoramento", {
          form,
          processo: this.object.tipo === "processo",
        })
        .then((monitoramento) => {
          this.label = "Monitorando";
          this.monitorando = true;
          let name = "aparicoes";
          let verificarStatusProcesso = false;
          if (
            typeof monitoramento !== "undefined" &&
            monitoramento.categoria === "PROCESSO"
          ) {
            name = "processo";
            verificarStatusProcesso = true;
          }

          window.location.href = subdomainUrl(
            "monitoramentos",
            `/${monitoramento.id}/processo`
          );

          this.$store.dispatch("showLoadingMessage", {
            message: "Monitoramento criado com sucesso",
            type: "done",
          });
        })
        .catch((result) => {
          let response = result && result.response ? result.response : null;
          this.label = "Monitorar processo";
          if (response && response.data && response.data.status === "failed") {
            let message = "";
            if (
              response.data.errors &&
              response.data.errors.constructor === Array
            ) {
              message = response.data.errors[0];
            } else {
              message = response.data.errors || response.data.message;
            }

            if (ERROS_LIMITE_CRIACAO_MONITORAMENTO.indexOf(message) > -1) {
              this.errorMessage = message;

              this.$store.dispatch("getPlanos").then(() => {
                this.showModalCampaign = true;
              });

              return;
            }

            this.$store.dispatch("showLoadingMessage", {
              message,
              type: "danger",
            });
          } else {
            let message = "Erro durante a criação do monitoramento :(";
            if (response && response.data && response.data.errors) {
              message = response.data.errors[0];
            }
            this.$store.dispatch("showLoadingMessage", {
              message,
              type: "danger",
            });
          }
        });
    },
  },
};
</script>
<style lang="stylus">
.is-hidden {
  display: none;
}
</style>
